// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum ChirpOperationMode {
	None = 0,
	Traffic_Counting = 1,
	Wrong_Way_Detection = 2,
	Parking_Monitor = 4,
	Intersection_Management = 8,
	Train_Station = 16,
	Attenuator_Truck = 32,
}

export const ChirpOperationModeDisplayNames: { [key in keyof typeof ChirpOperationMode]?: string} = {
	"None": "None",
	0 : "None",
	"Traffic_Counting": "Traffic_Counting",
	1 : "Traffic_Counting",
	"Wrong_Way_Detection": "Wrong_Way_Detection",
	2 : "Wrong_Way_Detection",
	"Parking_Monitor": "Parking_Monitor",
	4 : "Parking_Monitor",
	"Intersection_Management": "Intersection_Management",
	8 : "Intersection_Management",
	"Train_Station": "Train_Station",
	16 : "Train_Station",
	"Attenuator_Truck": "Attenuator_Truck",
	32 : "Attenuator_Truck",
}

export const getChirpOperationModeDisplayName = (key: ChirpOperationMode | number |  (keyof typeof ChirpOperationMode & string)) => {
	if (isNaN(+key)) return ChirpOperationModeDisplayNames[key];
	return Object.keys(ChirpOperationModeDisplayNames).filter(v => parseInt(v) >= 0 && (parseInt(v) & Number(key)) > 0).map(v => ChirpOperationModeDisplayNames[v as (keyof typeof ChirpOperationMode)]).join(', ');
}

